import { DatePipe } from '@angular/common';
import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BillingService } from '../../../../services/billing.service';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { ListService } from '../../../../shared/services/list.service';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { ActivatedRoute } from '@angular/router';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { DialogConfig, DialogService } from '../../../../shared/services/dialog.service';
import { UserService } from '../../../../services/user.service';
import { SectionsService } from '../../../../services/sections.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { ClaimReportComponent } from '../../claim-report/claim-report.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ClaimHierarchyComponent } from '../../claim-hierarchy/claim-hierarchy.component';

@Component({
  selector: 'ppl-billing-pmpm-claims-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent, ClaimReportComponent, NgxExtendedPdfViewerModule, ClaimHierarchyComponent],
  templateUrl: './billing-pmpm-claims-list.component.html',
  styleUrl: './billing-pmpm-claims-list.component.css'
})
export class BillingPmpmClaimsListComponent implements OnInit{
    sharedDataKey: string = STATIC_DATA.SHARED_PMPM_CLAIMS_DATA;
    pageId: string = PAGE_CONSTANTS.CLAIMS_PMPM_GRID_PAGE;
    programName!: string;
    appliedFilters: any;
    claims: any[] = [];
    cdrData: any[] = [];
    paymentData: any[] = [];
    claimReportData: any[] = [];
    resubClaimId: any;
    resubReason: any;
    id: any;
    pdfSrc: string | null = null;
    pdfMessage: string | null = null;
    hierarchyData: any;
    claimCols = [
      {
        field: 'code',
        header: 'Code',
        jsonpath: 'code'
      },
      {
        field: 'value',
        header: 'Value',
        jsonpath: 'value',
      }
    ];
    actionButtons: TableRowActionsModel = new TableRowActions({viewCDR: true, viewPdf: true, viewPayment: true, viewClaimReport: true, viewHierarchy: true});
    
  
    @ViewChild(ListTableComponent) childComponent!: ListTableComponent;
    @ViewChild('viewCDRDialog') viewCDRDialog!: TemplateRef<any>;
    @ViewChild('viewPaymentDialog') viewPaymentDialog!: TemplateRef<any>;
    @ViewChild('viewClaimReportDialog') viewClaimReportDialog!: TemplateRef<any>;
    @ViewChild('resubDialog') resubDialog!: TemplateRef<any>;
    @ViewChild('viewPdfDialog') viewPdfDialog!: TemplateRef<any>;
    @ViewChild('viewHierarchyDialog') viewHierarchyDialog!: TemplateRef<any>;
    private dialogSvc = inject(DialogService);
    
    cols = [];

    fields = [
      { field: 'timeframe', show: true, default: '30 days' },
      { field: 'status', show: true },
      { field: 'pplIcn', show: true },
      { field: 'participantPplId', show: true },
      { field: 'authNumber', show: false },
      { field: 'medicaidCin', show: true },
      { field: 'timesheetId', show: false },
      { field: 'mcoName', show: true },
      { field: 'serviceCode', show: true },
      { field: 'modifier', show: true },
      { field: 'pmpm', show: false },
      { field: 'year', show: true },
      { field: 'month', show: true },
      { field: 'batchName', show: true },
      { field: 'resub', show: true },
    ];
  
    constructor(
      private listService: ListService,
      private billingService: BillingService,
      private datePipe: DatePipe,
      private sharedDataService: SharedDataService,
      private route: ActivatedRoute,
      private userService: UserService,
      private logger : LoggerService, 
      private sectionService : SectionsService
    ) {}
  
    ngOnInit(): void {
      const selectedProgram = this.userService.getSelectedProgram();
      this.programName = selectedProgram?.program_code ?? '';
      const navigationState = window.history.state;
      this.getColumnData();
      if (navigationState.batchId) {
        const { batchId, pmpmflg } = navigationState;
        const filters = [];
        console.log(batchId);
        console.log(pmpmflg);
        filters.push({
          jsonPath: 'pmpmFlg',
          value: pmpmflg,
          operator: 'Equal',
        });
        filters.push({
          jsonPath: 'tasBillingBatchMasterId',
          value: batchId,
          operator: 'Equal',
        });
        this.searchClaims(filters);
      } else {
        console.log('No state data available');
      }
    }

    async getColumnData() {
      try {
          const tempCols = await this.sectionService.getJsonConfigurationData(
            STATIC_JSON_DATA_PATH.PMPM_CLAIMS_LIST_PAGE_HEADERS,
            'billing'
          );
          this.cols = tempCols.columns;
      } catch (e) {
        this.logger.debug('Error in getting column data', e);
      }
    }

    getPdfBlob(claimId:any) {
      const payload = {
        reportName:"fetchBatchClaims",
        mcoName:null,
        batchDate:null,
        reportBy:null,
        claimType:null,
        batchClaimId:claimId,
        claimFieldName:null,
        programCode:this.programName
      };
      this.billingService.getPDF(payload).subscribe({
        next: (blob) => {
          if(blob.type === 'application/pdf') {
            this.pdfMessage = null;
            const url = URL.createObjectURL(blob);
            this.pdfSrc = url;
            this.openPdfPopup();
          } else {
            this.pdfMessage = 'No valid PDF forms metadata found.';
            this.openPdfPopup();
          }
  
        },
        error: (err) => {
          console.error('Failed to fetch PDF:', err);
        }
      });
    }
  
    onSearch(filters: any) {
      this.appliedFilters = filters;
      this.searchClaims(filters);
    }
  
    buildRequestPayload(
      pageName: string,
      orderBy: string,
      searchParams: [],
      startingPageNumber = 1
    ) {
  
      const payload: any = {
        pageName: pageName,
        programCode: this.programName,
        condition: 'and',
        recordsPerPage: 20,
        startingPageNumber: startingPageNumber,
        searchParam: searchParams,
        orderByColumn: orderBy ? [orderBy] : [],
        orderBy: ['desc'],
      };
      return payload;
    }

    getHierarchyData(data: any){
      const payload = {...data}
      this.billingService
        .getHierarchyData(payload)
        .subscribe((data: any) => {
          if(data.status === 200){
            this.hierarchyData = data.responsedata;
            this.openViewHierarchyPopup(payload.pplIcn);
          }
        });
    }
    
    openViewHierarchyPopup(icn: any) {
      const dialogConfig: DialogConfig = {
        title: `Hierarchy - ${icn}`,
        isOkText: 'Save',
        size: 'xx-large',
        position: 'top',
        showClose: true,
        showButtons: false,
        styleClass: 'mrg-12'
      };
  
      this.dialogSvc.openDialog(
        this.viewHierarchyDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
    
    searchClaims(filters: any, startingPageNumber = 1, currentPage = 0) {
      if (startingPageNumber == 1) {
        this.claims = [];
      }
      const processedPayload = this.buildRequestPayload(
        'billingPMPMClaimsListView',
        'createddate',
        filters,
        startingPageNumber
      );

        this.listService
          .getListData(processedPayload, 'billing')
          .subscribe((data: any) => {
            const records = data.responsedata;
            records.forEach((element: any) => {
              element.serviceDate = this.datePipe.transform(element.serviceDate, 'MM/dd/yyyy');
              element.createddate = this.datePipe.transform(element.createddate, 'MM/dd/yyyy');
              element.pmpmBilledDate = this.datePipe.transform(element.pmpmBilledDate, 'MM/dd/yyyy');
              element.pmpmMonthYear = this.formatMonthYear(element.pmpmMonthYear);
              element.totalCharges = element.totalCharges ? this.billingService.formatCurrency(element.totalCharges) : element.totalCharges;
            });
            if (startingPageNumber > 1) {
              this.claims = [...this.claims, ...records];
              this.childComponent.resetPagination(startingPageNumber, currentPage);
            } else {
              this.claims = records;
            }
          });
    }

    getCDRData(icn: any): void {
      const payload = {
        "pageName": "billingCdrFileDetailView",
        "programCode": "NY",
        "condition": "and",
        "recordsPerPage": 20,
        "startingPageNumber": 1,
        "searchParam": [
          {
            "jsonPath": "pplIcn",
            "value": icn,
            "operator": "Equal"
          }
        ],
        "orderByColumn": ["createddate"],
        "orderBy": ["desc"]
      };
    
      this.listService
        .getListData(payload, 'billing')
        .subscribe((data: any) => {
          if(data.status === 200){
            const records = data.responsedata;
            records.forEach((element: any) => {
              element.createddate = this.datePipe.transform(
                element.createddate,
                'MM/dd/yyyy'
              );
            });
            this.cdrData = records;
            this.openViewCDRPopup();
          }
        });
    }
  
    getPaymentData(icn: any, batchName: any): void {
      const payload = {
        "pageName": "billingPaymentFileDetailListView",
        "programCode": "NY",
        "condition": "and",
        "recordsPerPage": 20,
        "startingPageNumber": 1,
        "searchParam": [
          {
            "jsonPath": "pplIcn",
            "value": icn,
            "operator": "Equal"
          },
          {
            "jsonPath": "lineItemControlNumber",
            "value": batchName,
            "operator": "Equal"
          }
        ],
        "orderByColumn": ["createddate"],
        "orderBy": ["desc"]
      };
    
      this.listService
        .getListData(payload, 'billing')
        .subscribe((data: any) => {
          if(data.status === 200){
            this.paymentData = data.responsedata;
            this.openViewPaymentPopup()
          }
        });
    }

    getClaimReportData(id: any): void {
      const payload = {
        "reportName": "fetchBatchClaims",
        "mcoName": null,
        "batchDate": null,
        "reportBy": null,
        "claimType": null,
        "batchClaimId": id,
        "claimFieldName": null,
        "programCode": this.programName
    }
    
      this.billingService
        .getClaimReportGridData(payload)
        .subscribe((data: any) => {
          if(data.status === 200){
            this.claimReportData = data.responsedata;
            this.openViewClaimReportPopup()
          }
        });
    }

      onAction(event: any) {
        if (event.action === 'viewCDR') {
          this.getCDRData(event.data.pplIcn);
        }
        if (event.action === 'viewPdf') {
          this.getPdfBlob(event.data.tasBillingBatchClaimDetailId);
        }
        if (event.action === 'viewPayment') {
          this.getPaymentData(event.data.pplIcn, event.data.batchName)
        }
        if (event.action === 'viewClaimReport') {
          this.id = event.data.tasBillingBatchClaimDetailId;
          this.getClaimReportData(event.data.tasBillingBatchClaimDetailId);
        }
        if (event.action === 'viewHierarchy') {
          const data = {
            programCode: this.programName,
            pplIcn: event.data.pplIcn
          }
          this.getHierarchyData(data);
        }
      }

      openPdfPopup() {
        const dialogConfig: DialogConfig = {
          title: 'Form',
          size: 'large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'mrg-12'
        };
    
        this.dialogSvc.openDialog(
          this.viewPdfDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
      }

      openViewClaimReportPopup() {
        const dialogConfig: DialogConfig = {
          title: 'Claim Report',
          size: 'large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'mrg-12'
        };
    
        this.dialogSvc.openDialog(
          this.viewClaimReportDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
      }

    formatMonthYear(monthYear: any) {
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      if (monthYear.length === 6) {
        const month = monthYear.substring(0, 2);
        const year = monthYear.substring(2);
        const monthName = monthNames[parseInt(month, 10) - 1];
        return `${monthName} ${year}`;
      }
      else if (monthYear.length === 4) {
        return monthYear;
      } else if (monthYear.length === 2) {
        const monthName = monthNames[parseInt(monthYear, 10) - 1];
        return monthName;
      } else {
        return null;
      }
    }
  
    rowClicked(event: any) {
      console.log('row clicked', event);
    }

    rowActions(event: any) {
      console.log('row actions', event);
      if(event.col.field === 'resubFlg' && event.event.resubFlg === 'Yes') {
        const id = event.event.tasBillingBatchClaimDetailId;
        this.billingService.getResubDetails(this.programName, id).subscribe((data:any)=>{
          console.log('data', data.responsedata);
          this.resubClaimId = data.responsedata[0].pplIcn;
          this.resubReason = data.responsedata[0].resubReason;
          this.openResubDetailsDialog();
        })
      }
    }

    onPageLoad(event: any) {
      this.searchClaims(
        this.appliedFilters,
        event.startingPageNumber,
        event?.first ?? 0
      );
    }

    openResubDetailsDialog() {
      const dialogConfig: DialogConfig = {
        title: 'Resubmission Details',
        size: 'medium',
        position: 'top',
        showClose: true,
        showButtons: false,
      };
  
      this.dialogSvc.openDialog(
        this.resubDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }

    openViewCDRPopup() {
        const dialogConfig: DialogConfig = {
          title: 'CDR Recon',
          isOkText: 'Save',
          size: 'xx-large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'mrg-12'
        };
    
        this.dialogSvc.openDialog(
          this.viewCDRDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
      }
    
      openViewPaymentPopup() {
        const dialogConfig: DialogConfig = {
          title: 'Payment Recon',
          isOkText: 'Save',
          size: 'xx-large',
          position: 'top',
          showClose: true,
          showButtons: false,
          styleClass: 'mrg-12'
        };
    
        this.dialogSvc.openDialog(
          this.viewPaymentDialog,
          dialogConfig,
          () => this.handleCancel(),
          () => this.handleCancel()
        );
      }
    
      handleCancel(){
    
      }
  
    clearData() {
      this.sharedDataService.clearData(this.sharedDataKey);
    }

}
